function checkLogo(imgUrl) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', function () {
            const {
                naturalHeight: nH,
                naturalWidth: nW
            } = this;
            (nH < 2 || nW < 2) ? reject() : resolve({ nW, nH });
        }, false);
        img.addEventListener('error', () => reject(), false);
        img.src = imgUrl;
    });
}

function setBgImg(container) {
    return (url) => container.style.backgroundImage = `url(${url})`;
}

export default (headerSelector, logoSelector) => {
    const header = document.querySelector(headerSelector);

    if (header === null) {
        return;
    }

    const logoContainer = header.querySelector(logoSelector);

    if (logoContainer === null || typeof(logoContainer.dataset) === 'undefined') {
        return;
    }

    const {
        src: customImg,
        fallback: fallbackImg,
        fallbackSystemThemeLogo,
    } = logoContainer.dataset;

    if (!customImg && !fallbackImg) {
        return;
    }

    const setLogoBgImg = setBgImg(logoContainer);

    if (customImg) {
        // MAIL-6141 - add background color for custom logo (for any theme)
        checkLogo(customImg)
            .then(({ nW, nH }) => {
                setLogoBgImg(customImg);
                // 1. get logo element by class 'branding__logo'
                const logoElement = document.querySelector('.branding__logo');
                if (logoElement) {
                    // MAIL-6630 define logo height (make white space around)
                    const targetHeight = 32;
                    // CALCULATE WIDTH FROM IMAGE HEIGHT: (original width / original height) * 32
                    const calculatedWidth = (nW / nH) * targetHeight;
                    logoElement.style.width = calculatedWidth + 'px';
                    const parentElement = logoElement.closest('.js-brand-logo-box');
                    if (parentElement) {
                        parentElement.classList.add('branding__wrap--nomail');
                    }
                }
            } )
            .catch(() => {
                setLogoBgImg(fallbackImg);
                if (fallbackSystemThemeLogo) {
                    logoContainer.dataset.systemThemeLogo = 'true';
                }
            });
    }
    else {
        setLogoBgImg(fallbackImg);
        if (fallbackSystemThemeLogo) {
            logoContainer.dataset.systemThemeLogo = 'true';
        }
    }
};
